import React, { ReactElement } from 'react'
import styles from './OwlPageHeader.module.scss'

interface OwlPageHeaderProps {
    text: string
    owlComponent: ReactElement
}
export const OwlPageHeader: React.FC<OwlPageHeaderProps> = (
    props
): ReactElement => {
    return (
        <div className={styles.owlPageHeader}>
            {props.owlComponent}

            <div className={styles.textContainer}>{props.text}</div>
        </div>
    )
}
